export const clientGroups = [
    {
      group_name: "Pertamina",
      label: "PERTAMINA GROUP",
      company_names: [
        "PERTAMINA (PERSERO)"
      ]
    },
    {
      group_name: "Garudafood", //client_id
      label: "GARUDAFOOD",
      company_names: [
        "GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "TUDUNG PUTRA PUTRI JAYA",
        "GARUDA TIMUR PACIFIC",
        "PT SINARNIAGA SEJAHTERA"
      ]
    },
    // {
    //   group_name: "Semen", //client_id
    //   label: "SEMEN INDONESIA GROUP",
    //   company_names: [ // subsidiary
    //     "SEMEN INDONESIA"
    //   ]
    // },
    // {
    //   group_name: "PLN",
    //   label: "PLN GROUP",
    //   company_names: [
    //     "PERUSAHAAN LISTRIK NEGARA, PT (PERSERO)"
    //   ]
    // },
    // {
    //   group_name: "United Tractor",
    //   label: "ASTRA - UNITED TRACTORS",
    //   company_names: [
    //     "UNITED TRACTORS"
    //   ]
    // },
    // {
    //   group_name: "Pupuk",
    //   label: "PUPUK INDONESIA",
    //   company_names: [
    //     "PUPUK INDONESIA PERSERO"
    //   ]
    // },
  ];